import {ReactNode, useContext, useEffect, useRef, useState} from "react";
import {GlobalSettingsContext, ViewTypes} from "./useGlobalSettingsContextProvider";
import {API} from "../API/api";
import {Helper} from "../Helper";

export const GlobalSettingsProvider = ({children} :{ children: ReactNode }) => {

    const [isFetching, setIsFetching] = useState<string[]>([]);

    const [listOfEMails, setListOfEMails] = useState<string[]>([])
    const refListOfEMails = useRef<string[]>([])

    const [newEMails, setNewEMails] = useState<boolean>(false)
    const [readedMails, setReadedMails] = useState<string[]>([])
    const [activeMission, setActiveMission] = useState<string|undefined>(undefined)

    const [userUUID, setUserUUID] = useState<string|undefined>(undefined)
    const [userName, setUserName] = useState<string|undefined>(undefined)
    const [userData, setUserData] = useState<{ GameMasterFor: string|undefined }>({ GameMasterFor: undefined });

    const [friends, setFriends] = useState<{name: string, uuid: string}[]>([])

    useEffect(() => {
        const user_uuid = localStorage.getItem('user_uuid');
        if( user_uuid && user_uuid !== '' )
            setUserUUID( user_uuid )

        const user_name = localStorage.getItem('user_name');
        if( user_name && user_name !== '' )
            setUserName( user_name );

        const active_mission = localStorage.getItem('active_mission');
        if( active_mission && active_mission !== '' )
            setActiveMission( active_mission );

        const friends = localStorage.getItem('friends');
        if( friends )
            setFriends( JSON.parse( friends ) );
    }, []);

    const Actions = {
        Fetching: {
            start: (type: string) => {
                setIsFetching ( _ => [...isFetching, type] )
            },
            stop: (type: string) => {
                setIsFetching ( _ => isFetching.filter( t => t !== type ) )
            },
        },
        setViewTo: ( view: string, id?: string ) => {
            // switch( view ){
            //     case ViewTypes.ListOfEmails:
            //         setNewEMails( false )
            //         break;
            //     case ViewTypes.EMail:
            //         setReadedMails( _ => [...readedMails, id || ''] )
            //         break;
            // }
            // setView({ section:view, id: id })
            // void navigate( Apps.find( a => a.target === view )?.path ?? '' )
        },
        readEMail: (id: string) => {
            setReadedMails( _ => [...readedMails, id] )
        },
        setActiveMission: (id: string) => {
            setActiveMission( _ => activeMission === id ? undefined : id )
        },
        deleteActiveMission: () => {
            setActiveMission( undefined )
        },
        profile: {
            reset: () => {
                setUserUUID( undefined );
                setUserData( { GameMasterFor: undefined } );
                setActiveMission( undefined )
            },
            generateUUID: () => {
                setUserUUID( crypto.randomUUID() );
                setUserData({ GameMasterFor: undefined });
            },
            setName: (name: string) => {
                setUserName( name );
                localStorage.setItem( 'user_name', name );
            }
        },
        friends: {
            add: (name: string, uuid: string) => {
                const _friends = [ ...friends, { name, uuid } ]
                setFriends( _ => _friends );

                localStorage.setItem( 'friends', JSON.stringify( _friends ) );
            },
            delete: (uuid: string) => {
                const _friends = friends.filter(friend => friend.uuid !== uuid)
                setFriends( _ => _friends );
                localStorage.setItem( 'friends', JSON.stringify( _friends ) );
            }
        }
    }

    useEffect(() => {
        const stored = localStorage.getItem('user_uuid');
        if( stored !== userUUID ) {
            if( userUUID ){
                localStorage.setItem( 'user_uuid', userUUID );
                fetching.user( userUUID );
            } else
                localStorage.setItem( 'user_uuid', '' );
        }
    }, [userUUID]);

    useEffect(() => {
        if( activeMission )
            localStorage.setItem('active_mission', activeMission );
        else
            localStorage.setItem('active_mission', '' );
    }, [activeMission]);

    const fetching = {
        user: (uuid?: string) => {
            Actions.Fetching.start('UserPrefFetching');
            const timer = setTimeout( () => {
                API.getUserPreferences( uuid ?? '' )
                    .then((res: { data: { GameMasterFor: string | undefined } }) => {
                        if( JSON.stringify(res.data) !== JSON.stringify( userData ) )
                            setUserData( res.data )
                    })
                    .catch(err => console.error(err))
                    .finally(() => Actions.Fetching.stop('UserPrefFetching'))
            }, 2000);
            return () => clearTimeout(timer);
        },
        emails: () => {
            Actions.Fetching.start('GlobalFetchListOfMails');
            const timer = setTimeout( () => {
                API.getListOfEMails( activeMission )
                    .then( (res : {data: {id: string}[]} ) => {
                        const responseData = res.data.map( a => a.id )
                        setListOfEMails( _ => responseData )
                    })
                    .catch( err => console.error(err) )
                    .finally( () => Actions.Fetching.stop( 'GlobalFetchListOfMails' ) )
            }, 2000 );
            return () => clearTimeout( timer );
        }
    }

    useEffect( () => {
        setInterval(() => {
            fetching.emails()
            fetching.user()
        }, 15000);
    }, [] )

    useEffect( () => {
        if( ! Helper.Arrays.AreEuqal( listOfEMails, refListOfEMails.current ) ) {
            refListOfEMails.current = listOfEMails
            setNewEMails(true)
        }
    }, [listOfEMails])


    return <GlobalSettingsContext.Provider value={{
        isFetching: isFetching.length > 0,
        // view: view,
        Mails: {
            new: readedMails.length !== listOfEMails.length,
            readed: readedMails
        },
        activeMission: activeMission,
        user: {
            uuid: userUUID,
            name: userName,
            data: userData
        },
        friends: friends,
        Actions: {
            Fetching: {
                start: Actions.Fetching.start,
                stop: Actions.Fetching.stop,
            },
            setViewTo: Actions.setViewTo,
            readEMail: Actions.readEMail,
            ActiveMission: {
                set: Actions.setActiveMission,
                delete: Actions.deleteActiveMission
            },
            profile: {
                reset: Actions.profile.reset,
                generateUUID: Actions.profile.generateUUID,
                setName: Actions.profile.setName
            },
            friends: {
                add: Actions.friends.add,
                delete: Actions.friends.delete
            }
        }
    }}>
        { children }
    </GlobalSettingsContext.Provider>
};

export default () => useContext(GlobalSettingsContext);